<template>
  <div class="UserConnections">

    <user-breadcrumbs :items="[{text: 'Connections'}]">
    </user-breadcrumbs>

    <user-toolbar :user="user">
    </user-toolbar>

    <connections-table :tokens="tokens"
                       :loading="busy"
                       @updated="fetchData">
    </connections-table>

  </div>
</template>
<script>
import {mapGetters} from 'vuex';
import UserBreadcrumbs from './components/UserBreadcrumbs';
import UserToolbar from './components/UserToolbar';
import userService from '../../services/userService';
import oauthService from "../../../../ml/services/oauthService";
import ConnectionsTable from "../user/components/ConnectionsTable";
import {orderBy} from 'lodash';

export default {
  components: {ConnectionsTable, UserToolbar, UserBreadcrumbs},
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
  metaInfo() {
    this.$store.commit('setTitle', 'Connections');
    return {
      title: this.$store.getters.title,
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: 'Users', exact: true, to: {name: 'users'},},
        {text: 'Show User'}
      ],
      busy: false,
      tokens: [],
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ])
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.busy) {
        return;
      }
      this.busy = true;
      oauthService.getTokens(this.user.id)
        .then(data => {
          this.tokens = orderBy(data, ['provider', 'created_at'], ['asc', 'desc']);
        })
        .finally(() => {
          this.busy = false;
        })
    }
  }
}
</script>
